import {Program, Texture, vec3, FrameBuffer} from '../../beam/index';
import DenoiserRenderPass from './DenoiserRenderPass'
import settings, {debugData} from '../settings'
import ssrVs from '../shaders/ssr-vs.glsl'
import ssdirectFs from '../shaders/ssdirect-fs.glsl'
import ssrFs from '../shaders/ssr-fs.glsl'
import ssresolveFs from '../shaders/ssresolve-fs.glsl'


function setUniform(uniforms, name, value) {
    if (uniforms[name]) {
        uniforms[name].value = value
    }
}

export default class SSRRenderPass {

    constructor(renderer, options) {
        this.renderer  = renderer
        this._uniforms = {}

        this.SSDirectMaterial = new Program(this.renderer.gl, {
            vertexShader: ssrVs,
            fragmentShader: ssdirectFs,
            // blend: true,
        });
        this.SSDirectMaterial.name = 'ssdirect'

        this.SSRMaterial = new Program(this.renderer.gl, {
            vertexShader: ssrVs,
            fragmentShader: ssrFs,
            defines: { USE_SSR: 1 }
        });
        this.SSRMaterial.name = 'SSRMaterial'

        this.SSGIMaterial = new Program(this.renderer.gl, {
            vertexShader: ssrVs,
            fragmentShader: ssrFs,
            defines: { USE_SSGI: 1 }
        });
        this.SSGIMaterial.name = 'SSGIMaterial'

        this.SSAOMaterial = new Program(this.renderer.gl, {
            vertexShader: ssrVs,
            fragmentShader: ssrFs,
            defines: { USE_SSAO: 1 }
        });
        this.SSAOMaterial.name = 'SSAOMaterial'

        this.SSResolveMaterial = new Program(this.renderer.gl, {
            vertexShader: ssrVs,
            fragmentShader: ssresolveFs,
        });



        this.SSResolveMaterial.name = 'ss resolve'

        let opt = {
            width:   1, height:  1, 
            linear: true, 
            type:   this.renderer.gl.FLOAT
        }

        //raw input
        this.directFrameBuffer     = new FrameBuffer(this.renderer.gl,  opt);

        this.aoFrameBuffer         = new FrameBuffer(this.renderer.gl, opt);
        this.aoDenoiserPass        = new DenoiserRenderPass(this.renderer, {useAtrouNoiseFilter: true, useDepthCheck: true, bilateralBlurIterations: 0})
        this.denoisedAOFrameBuffer = new FrameBuffer(this.renderer.gl, opt);
        
        this.irradianceFrameBuffer  = new FrameBuffer(this.renderer.gl,  opt);
        this.irradianceDenoisePass  = new DenoiserRenderPass(this.renderer, {useAtrouNoiseFilter: true, useDepthCheck: true, bilateralBlurIterations: 0})
        this.denoisedIrradianceFrameBuffer = new FrameBuffer(this.renderer.gl, opt);
        
        this.reflectionFrameBuffer  = new FrameBuffer(this.renderer.gl, opt);
        this.reflectionDenoiserPass = new DenoiserRenderPass(this.renderer, {useDepthCheck: false,/*useNeighbourgClipping:true, */useAtrouNoiseFilter: false, bilateralBlurIterations: 0, temporalThreshold: 0.9})
        this.denoisedReflectionFrameBuffer = new FrameBuffer(this.renderer.gl, opt);
    }


    resize(w, h) 
    {
        
        this.directMult      = settings.SSDirectScale//0.5;
        this.irrandianceMult = settings.SSGIScale;
        this.AOMult          = settings.SSAOScale;
        this.reflectionMult  = settings.SSRScale;

        // console.log('__W/H__',                      w, h);
        // console.log('SSDirectScale', settings.SSDirectScale);
        // console.log('SSGIScale', settings.SSGIScale);
        // console.log('SSAOScale', settings.SSAOScale);
        // console.log('SSRScale', settings.SSRScale);
        
        this.w = w;
        this.h = h;

        this.lowDirectFrameBuffer && this.lowDirectFrameBuffer.resize(this.w*(1/32),this.h*(1/32))
        this.directFrameBuffer && this.directFrameBuffer.resize(this.w/**this.directMult*/,this.h/**this.directMult*/);
        
        this.aoFrameBuffer && this.aoFrameBuffer.resize(this.w*this.AOMult,this.h*this.AOMult);
        this.aoDenoiserPass && this.aoDenoiserPass.resize(this.w*this.AOMult,this.h*this.AOMult);
        this.denoisedAOFrameBuffer && this.denoisedAOFrameBuffer.resize(this.w*this.AOMult,this.h*this.AOMult);
        
        this.irradianceFrameBuffer && this.irradianceFrameBuffer.resize(this.w*this.irrandianceMult,this.h*this.irrandianceMult);
        this.irradianceDenoisePass && this.irradianceDenoisePass.resize(this.w*this.irrandianceMult,this.h*this.irrandianceMult);
        this.denoisedIrradianceFrameBuffer && this.denoisedIrradianceFrameBuffer.resize(this.w*this.irrandianceMult,this.h*this.irrandianceMult);
        
        this.reflectionFrameBuffer && this.reflectionFrameBuffer.resize(this.w*this.reflectionMult,this.h*this.reflectionMult);
        this.reflectionDenoiserPass && this.reflectionDenoiserPass.resize(this.w*this.reflectionMult,this.h*this.reflectionMult);
        this.denoisedReflectionFrameBuffer && this.denoisedReflectionFrameBuffer.resize(this.w*this.reflectionMult,this.h*this.reflectionMult);

        this.resultBuffer && this.resultBuffer.resize( this.w,this.h); 

    }

    render(bufferScene, bufferPlane, bufferCamera, input, output, depthTexture, lastDepthTexture) 
    {

        this.SSDirectMaterial.setDefine("USE_CENTER_SHADOWS", settings.useCenterShadows && settings.canCenterShadows ? 1 : null)
        this.SSDirectMaterial.setDefine("USE_AREA_LIGHTS", settings.useAreaLights ? 1 : null)
        this.SSDirectMaterial.setDefine("USE_PCSS", settings.useSoftShadows ? 1 : null)
        this.SSDirectMaterial.setDefine("USE_IBL", settings.useIBL ? 1 : null)
        this.SSDirectMaterial.setDefine("NUM_LIGHTS", settings.numLights)
        this.SSResolveMaterial.setDefine("USE_IBL", settings.useIBL ? 1 : null)
        this.SSResolveMaterial.setDefine("USE_FOG", settings.useFog ? 1 : null)


        this._uniforms.useSSDirect = this.useSSDirect && settings.useSSDirect ? 1 : 0;
        this._uniforms.useSSAO =     this.useSSAO && settings.useSSAO ? 1 : 0;
        this._uniforms.useSSGI =     this.useSSGI && settings.useSSGI ? 1 : 0;
        this._uniforms.useSSR =      this.useSSR && settings.useSSR ? 1 : 0;

        this._uniforms.uSkipDirect =   settings.uSkipDirect ? 1 : 0;


        this.SSResolveMaterial.setDefine("USE_SSDIRECT", this.useSSDirect && settings.useSSDirect ? 1 : null)
        this.SSResolveMaterial.setDefine("USE_SSAO", this.useSSAO && settings.useSSAO ? 1 : null)
        this.SSResolveMaterial.setDefine("USE_SSR", this.useSSR && settings.useSSR ? 1 : null)
        this.SSResolveMaterial.setDefine("USE_SSGI", this.useSSGI && settings.useSSGI ? 1 : null)
                
        
        this._uniforms.tInput =            input
        this._uniforms.tReflection =       input;
        this._uniforms.tDirect =           input;
        this._uniforms.tAO =               input;
        
        this._uniforms.uSSRBias =          settings.uSSRBias 
        this._uniforms.uSSRMaxDist =       settings.uSSRMaxDist * settings.sceneDownscale 
        this._uniforms.uSSRMaxDrawDist =   settings.uSSRMaxDrawDist * settings.sceneDownscale
        this._uniforms.uSSAODistMult =     settings.uSSAODistMult
        
        this._uniforms.uSSStepMulitplier =     settings.uSSStepMulitplier

        this._uniforms.useSSShadow =       settings.useSSShadow ? 1 : 0;
        this._uniforms.uSSRDist =          settings.uSSRDist  * settings.sceneDownscale 
        this._uniforms.uSSRSteps =         settings.uSSRSteps 
        this._uniforms.uSSRStep =          settings.uSSRStep  * settings.sceneDownscale 
        this._uniforms.uSSRStart =         settings.uSSRStart  * settings.sceneDownscale 
        this._uniforms.uSSAODist =         settings.uSSAODist  * settings.sceneDownscale 
        this._uniforms.uSSAOSteps =        settings.uSSAOSteps 
        this._uniforms.uSSAOStep =         settings.uSSAOStep  * settings.sceneDownscale 
        this._uniforms.uSSAOStart =        settings.uSSAOStart  * settings.sceneDownscale 
        this._uniforms.uAODist =           settings.uAODist * settings.sceneDownscale 
        this._uniforms.uSSAOMult =         settings.uSSAOMult 
        this._uniforms.uSSAOSamples =      settings.uSSAOSamples 
        this._uniforms.uSSGIDist =         settings.uSSGIDist * settings.sceneDownscale 
        this._uniforms.uSSGISteps =        settings.uSSGISteps
        this._uniforms.uSSGIStep =         settings.uSSGIStep * settings.sceneDownscale 
        this._uniforms.uSSGIStart =        settings.uSSGIStart * settings.sceneDownscale 
        this._uniforms.uSSGISamples =      settings.uSSGISamples 
        this._uniforms.uSSGIMult =         settings.uSSGIMult 
        this._uniforms.uSSShadowDist =     settings.uSSShadowDist  * settings.sceneDownscale 
        this._uniforms.uSSShadowSteps =    settings.uSSShadowSteps 
        this._uniforms.uSSShadowStep =     settings.uSSShadowStep  * settings.sceneDownscale 
        this._uniforms.uSSShadowStart =    settings.uSSShadowStart  * settings.sceneDownscale 
        this._uniforms.useSSCheckerboard = settings.useSSCheckerboard ? 1 : 0;





        // this._uniforms.uSSRClamp         = settings.uSSRClamp ? 1 : 0
        // this._uniforms.uSSGIClamp        = settings.uSSGIClamp ? 1 : 0

        for (let u in this._uniforms) {
            setUniform(this.SSDirectMaterial.uniforms, u, this._uniforms[u])
            setUniform(this.SSGIMaterial.uniforms, u, this._uniforms[u])
            setUniform(this.SSAOMaterial.uniforms, u, this._uniforms[u])
            setUniform(this.SSRMaterial.uniforms, u, this._uniforms[u])
            setUniform(this.SSResolveMaterial.uniforms, u, this._uniforms[u])
        }
        
        /** DEFERED SHADING */
        if (this.useSSDirect && settings.useSSDirect) {
            // console.timeStamp && console.timeStamp('DeferredDirectPass');
            this.renderer.clearColor(0,0,0,1)
            this.renderer.clear()
            if (this.SSDirectMaterial.uniforms.uSSRResolution) {
                this.SSDirectMaterial.uniforms.uSSRResolution.value = [this.w/**this.directMult*/,this.h/**this.directMult*/]
            }
            bufferPlane.material = this.SSDirectMaterial;
            bufferPlane.id = 'DefferedDirectPass' 
            bufferPlane.name = 'DefferedDirectPass'
            this.renderer.render( bufferScene, bufferCamera, this.directFrameBuffer );//settings.extraPerfBoost ? undefined :this.directFrameBuffer );
            if (this.SSResolveMaterial.uniforms.tDirect) {
                this.SSResolveMaterial.uniforms.tDirect.value  = this.directFrameBuffer;
            }

            debugData.renderPasses.push({name: '-- DefferedDirect', buffer: this.directFrameBuffer })

        }

        // if (settings.extraPerfBoost) {
        //     return;
        // }

        /** AO */
        if (this.useSSAO  && settings.useSSAO) {
            bufferPlane.material =	this.SSAOMaterial
            // console.timeStamp && console.timeStamp('SSAOPass');
            this.renderer.clearColor(0,0,0,0)
            this.renderer.clear()
            bufferPlane.id = 'SSAOPass'
            bufferPlane.name = 'SSAOPass'
            this.renderer.render( bufferScene, bufferCamera, this.aoFrameBuffer );
            debugData.renderPasses.push({name: '-- SSAORenderPass', buffer: this.aoFrameBuffer })
            if (this.SSResolveMaterial.uniforms.tAO){
                this.SSResolveMaterial.uniforms.tAO.value = this.aoFrameBuffer;
            }

            if (settings.useTemporalNoiseFilter) {
                // console.timeStamp && console.timeStamp('SSAODenoisePass');
                this.aoDenoiserPass.useAtrouNoiseFilter = settings.useAtrouNoiseFilter
                this.aoDenoiserPass.bilateralBlurIterations = settings.SSAOBlurIterations
                bufferPlane.id = 'SSAODenoiserPass'
                bufferPlane.name = 'SSAODenoiserPass'
                this.aoDenoiserPass.render( bufferScene, bufferPlane, bufferCamera, this.aoFrameBuffer, this.denoisedAOFrameBuffer, depthTexture, lastDepthTexture );
                debugData.renderPasses.push({name: '-- SSAODenoiserRenderPass', buffer: this.denoisedAOFrameBuffer })
                if (this.SSResolveMaterial.uniforms.tAO){
                    this.SSResolveMaterial.uniforms.tAO.value = this.denoisedAOFrameBuffer;
                }

            }
        }

        /** GI */
        if (this.useSSGI && settings.useSSGI)  {
            bufferPlane.material =	this.SSGIMaterial
            if (settings.debugPerf) {
                console.timeStamp && console.timeStamp('SSGIPass');
            }
            this.renderer.clearColor(0,0,0,0)
            this.renderer.clear()
            if (this.SSGIMaterial.uniforms.tDirect) {
                this.SSGIMaterial.uniforms.tDirect.value  = this.directFrameBuffer//settings.useLowDirect ? this.lowDirectFrameBuffer : this.directFrameBuffer;
            }
            bufferPlane.id = 'SSGIPass'
            bufferPlane.name = 'SSGIPass'
            this.renderer.render( bufferScene, bufferCamera, this.irradianceFrameBuffer );
            debugData.renderPasses.push({name: '-- SSGIPassRenderPass', buffer: this.irradianceFrameBuffer })
            if (this.SSResolveMaterial.uniforms.tIrradiance) {
                this.SSResolveMaterial.uniforms.tIrradiance.value = this.irradianceFrameBuffer;
            }
            if (settings.useTemporalNoiseFilter) {
                if (settings.debugPerf) {
                    console.timeStamp && console.timeStamp('SSGIDenoisePass');
                }
                this.irradianceDenoisePass.temporalThreshold = settings.uTemporalThreshold
                // this.irradianceDenoisePass.overrideSpatialThreshold = settings.SSGISpatialThreshold
                this.irradianceDenoisePass.useAtrouNoiseFilter = settings.useAtrouNoiseFilter
                this.irradianceDenoisePass.bilateralBlurIterations = settings.SSGIBlurIterations
                bufferPlane.id = 'SSGIDenoiserPass'
                bufferPlane.name = 'SSGIDenoiserPass'
                this.irradianceDenoisePass.render( bufferScene, bufferPlane, bufferCamera, this.irradianceFrameBuffer, this.denoisedIrradianceFrameBuffer, depthTexture, lastDepthTexture );
                debugData.renderPasses.push({name: '-- SSGIDenoiserRenderPass', buffer: this.denoisedIrradianceFrameBuffer })
                if (this.SSResolveMaterial.uniforms.tIrradiance) {
                    this.SSResolveMaterial.uniforms.tIrradiance.value = this.denoisedIrradianceFrameBuffer;
                }
            }
        }
         
        /** SPECULAR */
        if (this.useSSR && settings.useSSR) {
            bufferPlane.material =	this.SSRMaterial
            if (settings.debugPerf) {
                console.timeStamp && console.timeStamp('SSRPass');
            }
            this.renderer.clearColor(0,0,0,0)
            this.renderer.clear()
            if (this.SSRMaterial.uniforms.tDirect) {
                this.SSRMaterial.uniforms.tDirect.value  = this.directFrameBuffer//settings.useLowDirect ? this.lowDirectFrameBuffer : this.directFrameBuffer;
            }
            bufferPlane.id = 'SSRPass'
            bufferPlane.name = 'SSRPass'
            this.renderer.render( bufferScene, bufferCamera, this.reflectionFrameBuffer );
            debugData.renderPasses.push({name: '-- SSRRenderPass', buffer: this.reflectionFrameBuffer })
            if (this.SSResolveMaterial.uniforms.tReflection) {
                this.SSResolveMaterial.uniforms.tReflection.value = this.reflectionFrameBuffer;
            }
            if (settings.useTemporalNoiseFilter) {    
                if (settings.debugPerf ) {
                    console.timeStamp && console.timeStamp('SSRDenoisePass');
                }
                this.reflectionDenoiserPass.useAtrouNoiseFilter = false
                this.reflectionDenoiserPass.bilateralBlurIterations = 0
                bufferPlane.id = 'SSRPassDenoiser'
                bufferPlane.name = 'SSRPassDenoiser'
                this.reflectionDenoiserPass.render( bufferScene, bufferPlane, bufferCamera, this.reflectionFrameBuffer, this.denoisedReflectionFrameBuffer, depthTexture );
                debugData.renderPasses.push({name: '-- SSRDenoiserRenderPass', buffer: this.denoisedReflectionFrameBuffer })
                if (this.SSResolveMaterial.uniforms.tReflection) {
                    this.SSResolveMaterial.uniforms.tReflection.value  = this.denoisedReflectionFrameBuffer
                }
            }
        }


        // only if profile mode is < HD, we can add optional ambient light to compensate for the lack of SSGI/SSR
        if (this.SSResolveMaterial.uniforms.useAmbientLight) {
            this.SSResolveMaterial.uniforms.useAmbientLight.value  = settings.useAmbientLight && settings.profile < 3 ? 1 : 0;
        }
        if (this.SSResolveMaterial.uniforms.uAmbientLight) {
            this.SSResolveMaterial.uniforms.uAmbientLight.value  = settings.uAmbientLight  
        }
      

        
        //MERGE ALL Scren space LIGHTINGS PASSES
        // console.timeStamp && console.timeStamp('SSResolvePass');
        bufferPlane.material = this.SSResolveMaterial;
        this.renderer.clearColor(0,0,0,0)
        this.renderer.clear()
        if (this.SSResolveMaterial.uniforms.tDirect) {
            this.SSResolveMaterial.uniforms.tDirect.value  = this.directFrameBuffer;
        }
        if (this.SSResolveMaterial.uniforms.uSSRResolution) {
            this.SSResolveMaterial.uniforms.uSSRResolution.value = [this.w/**this.directMult*/,this.h/**this.directMult*/]
        }
        bufferPlane.name = 'SSCopyPass'
        bufferPlane.id = 'SSCopyPass'
        this.renderer.render( bufferScene, bufferCamera, settings.extraPerfBoost ? undefined : output );
        debugData.renderPasses.push({name: '-- SSCopyRenderPass', buffer: output })


    }

}